import type { GqlDutchiePosLoyaltyConfig, GqlEnterpriseLoyaltySettingsQuery, GqlRewardsListV2 } from 'types/graphql';

export type Enterprise = GqlEnterpriseLoyaltySettingsQuery['enterpriseLoyaltySettings'];

export const FLOW_STEPS = {
  LANDING: 'landing',
  LOGIN_METHOD: 'login-method',
  EMAIL_SIGNUP: 'email-signup',
  LOYALTY_REWARDS: 'loyalty-rewards',
} as const;

export type FlowStep = typeof FLOW_STEPS[keyof typeof FLOW_STEPS];

export type LandingPageProps = {
  enterprise: Enterprise;
  onStartEarningRewards: (selectedState: string) => void;
};

export type LoginMethodSelectionProps = {
  onContinueWithEmail: () => void;
};

export type LoyaltyRewardsProps = {
  enterprise: Enterprise;
  rewards?: GqlRewardsListV2 | null;
  loyaltyConfigData?: GqlDutchiePosLoyaltyConfig | null;
  rewardsDataLoading?: boolean;
  loyaltyConfigLoading?: boolean;
};
